var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"row-content",class:_vm.containerClass},[_c('div',{staticClass:"t-overflow"},[_c('i',{staticClass:"fa fa-users t-secondary t-xs mr-1"}),_c('span',{staticClass:"t-600 t-sm",domProps:{"innerHTML":_vm._s(_vm.getOwnersAsString())}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }